import { RoleSelection } from "@/features/auth/components/RoleSelection";
import { AuthLayout } from "@/features/layout/AuthLayout";

const SignInPage = () => {
  return <RoleSelection authType="signin" />;
};

export default SignInPage;

SignInPage.getLayout = function getLayout(page) {
  return (
    <AuthLayout hasFooter authType="signin">
      {page}
    </AuthLayout>
  );
};
